
/**
 * ProduPneu — Admin Routes
 *
 * All routes require authentication and the admin role.
 * No development authentication bypass.
 */

const adminMeta = (title) => ({
  layout: "admin",
  title,
  requiresAuth: true,
  roles: ["admin"],
});

export default [
  // Dashboard
  {
    path: "/admin",
    name: "admin.dashboard",
    component: () => import("../pages/admin/Dashboard.vue"),
    meta: adminMeta("Tableau de bord"),
  },

  // Orders
  {
    path: "/admin/orders",
    name: "admin.orders",
    component: () => import("../pages/admin/Orders.vue"),
    meta: adminMeta("Gestion des commandes"),
  },

  // Products
  {
    path: "/admin/products",
    name: "admin.products",
    component: () => import("../pages/admin/Products.vue"),
    meta: adminMeta("Gestion des produits"),
  },

  // Customers
  {
    path: "/admin/customers",
    name: "admin.customers",
    component: () => import("../pages/admin/Customers.vue"),
    meta: adminMeta("Gestion des clients"),
  },

  // Garages
  {
    path: "/admin/garages",
    name: "admin.garages",
    component: () => import("../pages/admin/Garages.vue"),
    meta: adminMeta("Garages partenaires"),
  },

  // Appointments
  {
    path: "/admin/appointments",
    name: "admin.appointments",
    component: () => import("../pages/admin/Appointments.vue"),
    meta: adminMeta("Gestion des rendez-vous"),
  },

  // Deliveries
  {
    path: "/admin/deliveries",
    name: "admin.deliveries",
    component: () => import("../pages/admin/Deliveries.vue"),
    meta: adminMeta("Gestion des livraisons"),
  },
];
